import React, { useState } from 'react';
import { MenuContext } from '../contexts/MenuContext';

const MenuProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const setOpen = () => setIsOpen(true);
  const setClosed = () => setIsOpen(false);

  return (
    <MenuContext.Provider value={{ isOpen: isOpen, setOpen, setClosed }}>
      {children}
    </MenuContext.Provider>
  );
};

export default MenuProvider;
